import store from '../../store/store'

import('./data_type_buttons.css')

export default function DataTypeButtons(opts={}){
    BaseConstructor.call(this)
    let {container='#canvas'} = opts
    let elements = {}
    let context = this
    let current = 'level'

    init()
    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    function init(){

        elements.container = context.createElement('div', 'data-type-buttons-container', '')
        elements.button_level = context.createElement('button', 'data-type-button active', 'nível')
        // elements.button_flow = context.createElement('button', 'data-type-button', 'vazão')
        elements.button_config = context.createElement('button', 'data-type-button config', '<span class="fas fa-cog"></span>')

        $(elements.container).append(elements.button_level, elements.button_flow, elements.button_config)

        $(elements.button_flow).on('click', ()=>{
            if(current != 'flow'){
                store.mainConfigStore.setDataShow('level', false)
                store.mainConfigStore.setDataShow('flow', true)
                $(elements.button_flow).addClass('active')
                $(elements.button_level).removeClass('active')
                current = 'flow'
            }
            
        })
        $(elements.button_level).on('click', ()=>{
            if(current != 'level'){
                store.mainConfigStore.setDataShow('flow', false)
                store.mainConfigStore.setDataShow('level', true)
                $(elements.button_flow).removeClass('active')
                $(elements.button_level).addClass('active')
                current = 'level'
            }
        })

        $(elements.button_config).on('click', () =>{
            store.mainConfigStore.setConfigModalVisibility(true)
        })
        
        $(container).append(elements.container)
    }
}

DataTypeButtons.prototype = Object.create(BaseConstructor.prototype)